import React from 'react';
import TopBar from '../components/spiick/TopBar';
import Header from '../components/spiick/Header';
import Hero from '../components/spiick/Hero';
import HowItWorks from '../components/spiick/HowItWorks';
import SpiickMethod from '../components/spiick/SpiickMethod';
import FounderQuote from '../components/spiick/FounderQuote';
import AgeGrid from '../components/spiick/AgeGrid';
import FAQ from '../components/spiick/FAQ';
import Testimonials from '../components/spiick/Testimonials';
import Safety from '../components/spiick/Safety';
import Footer from '../components/spiick/Footer';

export default function SpiickLanding() {
  return (
    <main className="w-full bg-white" style={{ overflowX: 'clip' }}>
      <TopBar />
      <Header />
      <Hero />
      <HowItWorks />
      <SpiickMethod />
      <FounderQuote />
      <AgeGrid />
      <FAQ />
      <Testimonials />
      <Safety />
      <Footer />
    </main>
  );
}
